import { Reveal, SectionHead } from "@/components/Reveal";
import { habits } from "@/config/site.config";

export const ModulesSection = () => (
  <section data-testid="habits-section" className="border-y border-white/10 bg-coal">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="YOUR FUTURE IS BUILT IN THE ORDINARY DAY" center>
        7 QUANTUM
        <br />
        <span className="font-serif italic font-medium text-lime">HABITS™</span>
      </SectionHead>

      <Reveal className="mx-auto mb-12 max-w-xl text-center">
        <p className="text-base text-cream/70 sm:text-lg">
          Seven daily rituals designed to close the distance between the vision you can see and the woman
          capable of living it.
        </p>
      </Reveal>

      <div className="grid items-start gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7" data-testid="habits-list">
          {habits.map((h, i) => (
            <Reveal key={h.n} delay={Math.min(i * 0.04, 0.3)}>
              <div className="group flex items-baseline gap-5 border-b border-white/10 py-5 sm:gap-8">
                <span className="font-serif text-3xl italic text-lime/80 transition-colors group-hover:text-lime sm:text-4xl">
                  {h.n}
                </span>
                <div>
                  <h3 className="text-base font-extrabold tracking-wide text-cream sm:text-lg">{h.title}</h3>
                  <p className="mt-1 text-sm text-cream/55">{h.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="lg:col-span-5" delay={0.15}>
          <figure className="lg:sticky lg:top-24">
            <div className="overflow-hidden border border-white/10 shadow-[0_30px_60px_rgba(0,0,0,0.5)]">
              <img
                src="/assets/inside-rituals.jpg"
                alt="Inside the 7 Daily Rituals members area"
                loading="lazy"
                className="w-full object-cover"
                data-testid="habits-inside"
              />
            </div>
            <figcaption className="mt-2 text-center font-mono text-[9px] tracking-[0.3em] text-cream/40">
              INSIDE THE MEMBERS AREA
            </figcaption>
          </figure>
        </Reveal>
      </div>

      <Reveal className="mt-20 text-center">
        <p className="text-2xl font-extrabold leading-tight tracking-tight sm:text-4xl">
          YOUR FUTURE ISN’T CREATED BY
          <br />
          WHAT YOU WANT OCCASIONALLY.
        </p>
        <p className="mt-3 font-serif text-2xl italic leading-tight text-lime sm:text-4xl">
          IT’S CREATED BY WHAT YOU
          <br />
          EMBODY REPEATEDLY.
        </p>
      </Reveal>
    </div>
  </section>
);
